import Vue from 'vue';
import { createObservableDict } from "../../lib/utils/collections/ObservableDict";
import { vueBailDepCollector } from "../../lib/utils";
/**
 * 对于每一个需要渲染的地方（一般为 CRenderer 实例），
 * 都需初始化这么一个 Context。
 *
 * 在每次触发渲染时，
 * 传递这个玩意给 VNodeFactory 的 toVNode 方法。
 *
 * VNodeFactory 会改写这个里面的东西
 */
export class VNodeFactoryContext {
  constructor(renderer) {
    this.refreshRenderCounter = Vue.observable({
      value: 0
    });
    this.watcher = new Vue({});
    renderer.$once('hook:beforeDestroy', () => this.watcher.$destroy());
    this.renderer = renderer;
    this.reset();
  }
  setComponentInstance(compPath, inst) {
    if (this.isPartialRenderer) {
      // 递归向上设置
      this.renderer.ucVNodeFactoryContext.setComponentInstance(compPath, inst);
    }
    vueBailDepCollector(() => {
      const prev = this.componentInstances[compPath];
      if (prev === inst) return;
      if (!prev && !inst) return;
      if (!inst) delete this.componentInstances[compPath];else this.componentInstances[compPath] = inst;
    });
  }
  emitChange() {
    this.refreshRenderCounter.value += 1;
  }
  /** 添加依赖 */
  depend() {
    // Vue依赖收集
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.refreshRenderCounter.value;
  }
  reset() {
    this.factoryStates = {};
    this.componentInstances = createObservableDict();
  }
}
//# sourceMappingURL=VNodeFactoryContext.js.map
